const data = {
    state: {
        ucUserInfo: {},
        token: localStorage.getItem('token') ? localStorage.getItem('token') : '',
        languageList: localStorage.getItem('languageList') ? JSON.parse(localStorage.getItem('languageList')) : []
    },
    mutations: {
        // 登陆时设置信息
        SET_LOGIN_INFO(state, info) {
            localStorage.setItem('token', info.token);
            state.token = info.token;
            state.ucUserInfo = info.ucUserInfo;
        },
        // 用户登出 - 其他系统中转退出
        USER_SIGN_OUT_OTHERSYSTEM(state) {
            localStorage.setItem('token', '');
            state.token = '';
            state.ucUserInfo = {};
            localStorage.setItem('lang', '');
            localStorage.setItem('languageList', []);
            window.location.href = process.env.VUE_APP_WORK_ORDER_URL_IOPORTAL;
        },
        // 用户登出 - Io Portal自己退出
        USER_SIGN_OUT(state) {
            localStorage.setItem('token', '');
            state.token = '';
            state.ucUserInfo = {};
            localStorage.setItem('lang', '');
            localStorage.setItem('languageList', []);
            window.location.href = process.env.VUE_APP_WORK_ORDER_URL_USERCENTER + '/auth/logout?idp=gigya';
        },
        // 设置用户多语言
        SET_LANGUAGELIST(state, info) {
            localStorage.setItem('languageList', JSON.stringify(info));
            state.languageList = info;
        },
        // Cookie Preferences 的 配置信息 3:设置Cookie Preferences：采用script注入的方式
        SET_COOKIE_PREFERENCES(a, lang) {
            // 设置登录cookie
            const tryScript = document.createElement('script');
            tryScript.id = 'tryScript';
            tryScript.textContent = (`
          try {
            const website_cookie = window.location.origin + '/cookie-policy';
            const dom = document.getElementById('psa_tarteauxprunes_launcher');
            dom.setAttribute('data-cookie', website_cookie);
          } catch {}
        `);
            document.body.appendChild(tryScript);

            const dataLayerScript = document.createElement('script');
            dataLayerScript.id = 'dataLayerScript';
            dataLayerScript.textContent = (`
          window.dataLayer = window.dataLayer || [];
          dataLayer.push({
            "brand": "leapmotor",
            "language": "${lang}",
            "country": "xx",
            "siteTypeLevel1": "user center",
            "siteTypeLevel2": "other",
            "siteOwner": "central",
            "siteTarget": "[B2C|B2B]",
          })
        `);
            document.body.appendChild(dataLayerScript);
        },
    },
    actions: {}
};

export default data;